/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';
import { ResourceType } from '../models/ResourceType';

/**
* Grouping dimensions (e.g. cloudProvider, meteringDimension, etc.)
*/
export class CostDataRecordDimensions {
  'cloudProvider'?: Provider;
  'resourceType'?: ResourceType;
  /**
  * Eon-assigned resource ID
  */
  'resourceId'?: string;
  /**
  * Source account provider id
  */
  'sourceAccountProviderId'?: string;
  /**
  * Eon-assigned source account ID
  */
  'sourceAccountId'?: string;
  /**
  * Source account alias
  */
  'sourceAccountName'?: string;
  /**
  * Source account tags
  */
  'sourceAccountTags'?: { [key: string]: string; };
  /**
  * Source storage size in bytes
  */
  'sourceStorageSize'?: number;
  /**
  * Cloud provider resource ID
  */
  'providerResourceId'?: string;
  /**
  * Cloud provider resource name
  */
  'resourceName'?: string;
  /**
  * Cloud provider resource tags
  */
  'resourceTags'?: { [key: string]: string; };
  /**
  * Cloud provider resource region
  */
  'resourceSourceRegion'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceType",
      "format": ""
    },
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "sourceAccountProviderId",
      "baseName": "sourceAccountProviderId",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceAccountId",
      "baseName": "sourceAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "sourceAccountName",
      "baseName": "sourceAccountName",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceAccountTags",
      "baseName": "sourceAccountTags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "sourceStorageSize",
      "baseName": "sourceStorageSize",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "providerResourceId",
      "baseName": "providerResourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceTags",
      "baseName": "resourceTags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "resourceSourceRegion",
      "baseName": "resourceSourceRegion",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CostDataRecordDimensions.attributeTypeMap;
  }

  public constructor() {
  }
}



